<div class="item-child d-flex" (click)="item.open = !item.open" [attr.aria-expanded]="!item.open" aria-controls="collapseBasic">
    <div class="w-75">{{item.title}}</div>
    <div class="text-right mr-2 w-25"><i [ngClass]="{'fa-angle-up': item.open,'fa-angle-down': !item.open}" class="fa" aria-hidden="true"></i></div>
</div>
<ul id="collapseBasic" [collapse]="item.open" [isAnimated]="true">
    <li *ngFor="let m of item.main">
        <div class="item-child" (click)="closeSideBar()" routerLink="/item/{{m.slug}}">{{m.name}}</div>
    </li>
</ul>